import type CalendarSearchResultItem from '../schema/CalendarSearchResultItem';
import type InstrumentationContext from '../schema/InstrumentationContext';
import { action } from 'satcheljs';
import type { CalendarSearchListViewState } from '../schema/CalendarSearchListViewState';

/**
 * Action to initialize / reset search results store
 */
export let initSearchResults = action('initSearchResults');

/**
 * Action to update the item Id for auto scroll
 */
export let setAutoScrollItemId = action('setAutoScrollItemId', (autoScrollItemId: number) => ({
    autoScrollItemId,
}));

/**
 * Action to set the current instrumentation context
 */
export let setCurrentInstrumentationContext = action(
    'setCurrentInstrumentationContext',
    (instrumentationContext: InstrumentationContext) => ({
        instrumentationContext,
    })
);

/**
 * Action to set the calendar search results
 */
export let setCalendarSearchResults = action(
    'setCalendarSearchResults',
    (calendarSearchResults: CalendarSearchResultItem[], clientSorted?: boolean) => ({
        calendarSearchResults,
        clientSorted,
    })
);

/**
 * Action to set the past day marker
 */
export let setPastDateMarker = action('setPastDateMarker', (isPastDayFound: boolean) => ({
    isPastDayFound,
}));

/**
 * Action to set the item index to be shown in SxS reading pane
 */
export let setReadingPaneItemIndex = action('setReadingPaneItemIndex', (itemIndex: number) => ({
    itemIndex,
}));

/**
 * Action to set the search mode
 */
export let setSearchMode = action('setSearchMode', (mode: CalendarSearchListViewState) => ({
    mode,
}));

/**
 * Action to set the flag that a full calendar item is being fetched.
 */
export let setFetchingFullItem = action('setFetchingFullItem', (setFetchingFullItem: boolean) => ({
    setFetchingFullItem,
}));

/**
 * Action to set the flag to whether show notifications or not
 */
export let setHideNotification = action('setHideNotification', (setHideNotification: boolean) => ({
    setHideNotification,
}));

/**
 * Action to set the search terms
 */
export let setSearchTerms = action('setSearchTerms', (searchTerms: string[]) => ({
    searchTerms,
}));

/**
 * Action to set the count of edited results in search
 */
export let setSearchResultsEdited = action(
    'setSearchResultsEdited',
    (isDeleteAction: boolean, isBirthdayUpdate?: boolean) => ({
        isDeleteAction,
        isBirthdayUpdate,
    })
);
